import { createFileRoute } from "@tanstack/react-router";
import { CarImages } from "@/components/admin/car-images";

export const Route = createFileRoute("/_auth/app/admin/cars")({
  component: CarsPage,
});

function CarsPage() {
  return <CarImages />;
}
